import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=60f28c02&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
import style0 from "./Home.vue?vue&type=style&index=0&id=60f28c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f28c02",
  null
  
)

export default component.exports
import {QCard,QItem,QItemSection,QAvatar,QImg,QItemLabel,QCardSection,QCardActions,QBtn,QCarousel,QCarouselSlide} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QItem,QItemSection,QAvatar,QImg,QItemLabel,QCardSection,QCardActions,QBtn,QCarousel,QCarouselSlide})
